export const numRatedBg = [
    "rgba(204, 204, 204, 0.6)","rgba(204, 204, 204, 0.6)","rgba(204, 204, 204, 0.6)","rgba(204, 204, 204, 0.6)",
                "rgba(119, 255, 119, 0.6)","rgba(119, 255, 119, 0.6)",
                "rgba(119, 221, 187, 0.6)","rgba(119, 221, 187, 0.6)",
                "rgba(170, 170, 255, 0.6)","rgba(170, 170, 255, 0.6)","rgba(170, 170, 255, 0.6)",
                "rgba(255, 136, 255, 0.6)","rgba(255, 136, 255, 0.6)",
                "rgba(255, 204, 136, 0.6)","rgba(255, 204, 136, 0.6)",
                "rgba(255, 187, 85, 0.6)",
                "rgba(255, 119, 119, 0.6)","rgba(255, 119, 119, 0.6)",
                "rgba(255, 51, 51, 0.6)","rgba(255, 51, 51, 0.6)","rgba(255, 51, 51, 0.6)","rgba(255, 51, 51, 0.6)",
                "rgba(170, 0, 0, 0.6)","rgba(170, 0, 0, 0.6)","rgba(170, 0, 0, 0.6)","rgba(170, 0, 0, 0.6)","rgba(170, 0, 0, 0.6)","rgba(170, 0, 0, 0.6)",
]